/**
 * Диагностика контура глазами браузера. Браузер видит шлюз только через один
 * origin клиента, а тот проксирует в Gateway лишь `/api/*` и `/auth/*`
 * (`apps/web/vite.config.ts`): корневые `/version` и `/ready` шлюза с origin
 * клиента недоступны (RP-U9, стенд — 404). Версия шлюза — из его ответа
 * «О приложении» (AU1b), готовность — `GET /api/gateway/v1/ready` (FIX-A2,
 * смысл `/ready`: шлюз настроен), обе — только с сессией. `/version` и
 * `/ready` служб Platform, 1С и AQSI шлюз не проксирует; диагностика служб по
 * ресурсу — ресурсные ручки native-пакетов (`diagnostics.read`).
 */
export const PLATFORM_DIAGNOSTICS_URLS = {
  gatewayStatus: '/api/gateway/v1/about',
  gatewayReady: '/api/gateway/v1/ready',
} as const
